import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFacultyApi } from '../api/allApi';

export const fetchFaculty = createAsyncThunk(
    'faculty/fetchFaculty',
    async (_, { rejectWithValue }) => {
        try {
            return await getFacultyApi();
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to fetch faculty');
        }
    }
);

const facultySlice = createSlice({
    name: 'faculty',
    initialState: { data: null, fetchLoading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFaculty.pending, (state) => {
                state.fetchLoading = true;
                state.error = null;
            })
            .addCase(fetchFaculty.fulfilled, (state, action) => {
                state.fetchLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchFaculty.rejected, (state, action) => {
                state.fetchLoading = false;
                state.error = action.payload;
            });
    },
});

export default facultySlice.reducer;